import { render, staticRenderFns } from "./ProducerRegistration.vue?vue&type=template&id=de9af1c0&scoped=true"
import script from "./ProducerRegistration.vue?vue&type=script&lang=js"
export * from "./ProducerRegistration.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ProducerRegistration.vue?vue&type=style&index=1&id=de9af1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9af1c0",
  null
  
)

export default component.exports